
$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (form !== undefined && form !== null && form.id === 'shipping') {
    const SwedenSpecificConfigureShippingMethod = (country) => {
      const list = $("[data-id='shippingMethodList']");
      list.find('.rdblistShippingMethodStep3').show();
            // list.find(".rdblistShippingMethodStep3 input:radio").attr("checked", "");

      if (country === 'Denmark') {
        list.find('.rdblistShippingMethodStep3').hide();
        list.find(".rdblistShippingMethodStep3[data-title='DK Standard']")
                    .show()
                    .find('input:radio')
                    .prop('checked', true);
      } else {
        list.find(".rdblistShippingMethodStep3[data-title='DK Standard']").hide();
        list.find(".rdblistShippingMethodStep3[data-title='Standard'] input:radio").prop('checked', true);
      }
      list.find('.rdblistShippingMethodStep3 input:radio').trigger('change');
    };

    SwedenSpecificConfigureShippingMethod(form.country());

    form.countryField.on('change', () => {
      SwedenSpecificConfigureShippingMethod(form.country());
    });
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/sweden.form.js